import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { PayByBankLogo } from "checkout-experience/components/payment-method/pay-options/pay-by-bank/pay-by-bank-logo";
import { PaymentMethodDisplay } from "checkout-experience/components/payment-method/payment-method-summary-display";
import { defaultCardWrapperStyle } from "checkout-experience/components/payment-method/payment-method-summary-display.css";
import { getPayByBankAccountTypeString } from "checkout-experience/utils/payment-helpers";

export const PayByBankPaymentSummary = ({
  last4digitsOfAccountNumber,
  bankName,
  accountType,
  institutionalLogo,
}: Omit<PaymentMethodDisplay, "paymentType"> & {
  institutionalLogo?: string;
}) => {
  const { t } = useTranslation("combined");

  return (
    <div className={defaultCardWrapperStyle}>
      <PayByBankLogo logoSrc={institutionalLogo} />
      <Text styleVariant="body">
        {bankName ? bankName + " " : ""}
        {accountType ? getPayByBankAccountTypeString(accountType) : ""}
        {t("payByBank.accountWithLast4", {
          last4: last4digitsOfAccountNumber,
        })}
      </Text>
    </div>
  );
};
